// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import 'vue-ydui/dist/ydui.base.css'
import YDUI from 'vue-ydui/dist/ydui.px.js'
import 'vue-ydui/dist/ydui.px.css'

Vue.config.productionTip = false
Vue.use(YDUI)

// 验证是否已登录
router.beforeEach((to, from, next) => {
  window.top.lastRoutePath = to.path
  if (to.query) {
    let params = ''
    for (let k in to.query) {
      if (k && k !== '') {
        let v = to.query[k]
        if (v && v !== '') {
          params += (params === '' ? '' : '&') + k + '=' + encodeURIComponent(v)
        }
      }
    }
    if (params !== '') {
      window.top.lastRoutePath = to.path + '?' + params
    }
  }
  if (to.path === '/login') {
    localStorage.removeItem('app_token')
    sessionStorage.removeItem('app_token')
  }
  // 判断进入的页面需不需要登录
  /*
  if (to.matched.some(res => res.meta.requireAuth)) { // requireAuth
    if (localStorage.getItem('app_token')) {
      next()
      return false
    } else {
      let jumpPath = to.path
      if (jumpPath === '/' || jumpPath === '') {
        jumpPath = '/home'
      }
      window.location.href = '/api/papi/jump' + jumpPath
      // next({ path: '/login', query: {redirect: to.fullPath} })
      // next('/403')
      // 或者在判断为没权限时跳到403 next('/403')
    }
  } else {
    next()
  } */
  next()
})

/* eslint-disable no-new */
window.top.myMainVue = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js